const AlertIcon = () => {
  return (
    <svg
      width="124"
      height="99"
      viewBox="0 0 124 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.5309 44.8815C93.5309 45.9827 94.4149 46.8762 95.505 46.8762C96.5951 46.8762 97.4791 45.9827 97.4791 44.8815C97.4791 43.7798 96.5951 42.8867 95.505 42.8867C94.4149 42.8867 93.5309 43.7798 93.5309 44.8815Z"
        stroke="#4666A4"
        strokeWidth="0.790473"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.7452 8.17443C42.7452 9.27614 43.6292 10.1692 44.7194 10.1692C45.8095 10.1692 46.693 9.27614 46.693 8.17443C46.693 7.07272 45.8095 6.17969 44.7194 6.17969C43.6292 6.17969 42.7452 7.07272 42.7452 8.17443Z"
        stroke="#4666A4"
        strokeWidth="0.790473"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7153 24.7852L25.0618 25.9688L24.7153 27.1525L25.899 26.806L27.0826 27.1525L26.7362 25.9688L27.0826 24.7852L25.899 25.1321L24.7153 24.7852Z"
        fill="#7E94BF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.7239 27.8008L56.6453 29.7724L54.6747 30.8505L56.6453 31.9291L57.7239 33.9007L58.802 31.9291L60.7731 30.8505L58.802 29.7724L57.7239 27.8008Z"
        fill="#DAE0ED"
      />
      <path
        d="M26.3258 94.4292H0.875347"
        stroke="#4666A4"
        strokeWidth="0.790473"
        strokeLinecap="round"
      />
      <path
        d="M29.3746 97.7338H6.80642"
        stroke="#4666A4"
        strokeWidth="0.790473"
        strokeLinecap="round"
      />
      <path
        d="M117.159 97.7338H94.5906"
        stroke="#4666A4"
        strokeWidth="0.790473"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.865 21.5469L114.786 23.5188L112.815 24.5971L114.786 25.6758L115.865 27.6483L116.943 25.6758L118.915 24.5971L116.943 23.5188L115.865 21.5469Z"
        fill="#C8D1E4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.0952 0L98.0169 1.9721L96.0458 3.05095L98.0169 4.12929L99.0952 6.10139L100.174 4.12929L102.145 3.05095L100.174 1.9721L99.0952 0Z"
        fill="#7E94BF"
      />
      <path
        d="M123.125 94.4272H97.6742"
        stroke="#4666A4"
        strokeWidth="0.790473"
        strokeLinecap="round"
      />
      <path
        d="M56.5816 56.2992L39.9092 85.4755C39.3654 86.4256 39.0806 87.5016 39.0834 88.5964C39.0862 89.6911 39.3766 90.7664 39.9252 91.7138C40.4738 92.6612 41.2614 93.4478 42.2095 93.9952C43.1576 94.5426 44.2329 94.8313 45.3277 94.8327H78.6724C79.7672 94.8313 80.8425 94.5426 81.7906 93.9952C82.7387 93.4478 83.5263 92.6612 84.0749 91.7138C84.6235 90.7664 84.9139 89.6911 84.9167 88.5964C84.9195 87.5016 84.6346 86.4256 84.0909 85.4755L67.4185 56.2992C66.8703 55.3469 66.0809 54.5555 65.1297 54.0055C64.1784 53.4555 63.0989 53.166 62 53.166C60.9012 53.166 59.8217 53.4555 58.8704 54.0055C57.9191 54.5555 57.1298 55.3469 56.5816 56.2992Z"
        fill="#EDF0F6"
        stroke="#4666A4"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M61.9918 59.1113V78.257"
        stroke="#4666A4"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M61.9918 85.6748C63.1233 85.6748 64.0748 86.6159 64.0748 87.8203C64.0746 89.0248 63.1229 89.9658 61.9918 89.9658C60.8607 89.9658 59.909 89.0248 59.9088 87.8203C59.9088 86.6159 60.8604 85.6748 61.9918 85.6748Z"
        fill="#4666A4"
        stroke="#4666A4"
        strokeWidth="2.08333"
      />
    </svg>
  );
};
export default AlertIcon;
